import TagDismissible, { type DismissibleProps } from './components/tag-dismissible'
import TagChoice, { type ChoiceProps } from './components/tag-choice'
import TagFilter, { type FilterProps } from './components/tag-filter'
import TagSearch, { type SearchProps } from './components/tag-search/tag-search'

type Dismissible = DismissibleProps & {
  variant: 'dismissible'
}

type Choice = ChoiceProps & {
  variant: 'choice'
}

type Filter = FilterProps & {
  variant: 'filter'
}

type Search = SearchProps & {
  variant: 'search'
}

type TagType = Dismissible | Choice | Filter | Search

export const Tag = (props: TagType) => {
  const { variant } = props

  return (
    <>
      {variant === 'dismissible' && <TagDismissible {...props} />}

      {variant === 'choice' && <TagChoice {...props} />}

      {variant === 'filter' && <TagFilter {...props} />}

      {variant === 'search' && <TagSearch {...props} />}
    </>
  )
}

export default Tag
